// extracted by mini-css-extract-plugin
export var activeConversationContainer = "_95-4 _95-1";
export var button = "_95-6";
export var conversationContainer = "_95-1";
export var conversationPreview = "_95-5";
export var iconContainer = "_95-0";
export var mergeModalConversationContainer = "_95-2";
export var pillContainer = "_95-3";